import {BaseWidget} from "./BaseWidget";

export class NumericFieldWidget extends BaseWidget {
    createElement(style) {
        return $(`<input class="full-width" type='number' ${style} id="${this.elementId}" nid="${this.id}">`);
    }

    setValueInElement(value) {
        this.numericField.value(value || 0);
    }

    readValueFromElement() {
        return this.numericField.value();
    }

    setEnabled(enabled) {
        this.numericField.enable(enabled === "Enabled" || enabled === true);
    }

    getNumericField(){
        return this.numericField;
    }
}